import {useParams} from "react-router-dom";
import {Content, Page} from "components/common";
import {DefaultPageWrapper} from "layouts";
import {IInvoice, InvoiceCreate, invoiceHooks, InvoicesListTable} from "features/invoices";
import useChangeDocumentTitle from "hooks/use-change-document-title";

export function QuoteInvoices(){
    const {quoteId} = useParams();
    const {isLoading:isLoadingInvoices, data: invoices } = invoiceHooks.useGet({
        populate: "*",
        filters: {
            quote: parseInt(quoteId!)
        }
    })
    useChangeDocumentTitle(`Invoices`)
    const {mutateAsync} = invoiceHooks.useCreate();

    async function onSubmitCreate(values: IInvoice) {
        return await mutateAsync({
            ...values,
            quote: quoteId
        });
    }

    return (
        <DefaultPageWrapper>
            <Page.Header>
                <Page.Title title="Invoices"/>
                <InvoiceCreate.Button onSubmitForm={onSubmitCreate}/>
            </Page.Header>
            <Page.Body>
                <Content.Section>
                    <Content.Body>
                        <InvoicesListTable
                            disableFields={['quote']}
                            data={invoices?.data}
                            loading={isLoadingInvoices}/>
                    </Content.Body>
                </Content.Section>
            </Page.Body>
        </DefaultPageWrapper>
    )
}